import { deleteMeeting, getActivities } from '../service/projects'

export interface MeetingDeletionResult {
  success: boolean
  deletedCount: number
  failedCount: number
  errors: string[]
}

export async function deleteAllMeetings(projectId: string): Promise<MeetingDeletionResult> {
  const result: MeetingDeletionResult = {
    success: true,
    deletedCount: 0,
    failedCount: 0,
    errors: [],
  }

  try {
    const activitiesData = await getActivities(projectId, 1)

    if (!activitiesData || !activitiesData.sessionMeetings) {
      return result
    }

    const meetings = activitiesData.sessionMeetings || []

    if (meetings.length === 0) {
      return result
    }

    for (const meeting of meetings) {
      try {
        await deleteMeeting(meeting.id)
        result.deletedCount++
      } catch (error: any) {
        result.failedCount++
        result.errors.push(`Failed to delete meeting ${meeting.id}: ${error.message}`)
        result.success = false
      }
    }

    return result
  } catch (error: any) {
    result.success = false
    result.errors.push(`Failed to fetch meetings: ${error.message}`)
    return result
  }
}

export async function hasMeetings(projectId: string): Promise<boolean> {
  try {
    const activitiesData = await getActivities(projectId, 1)

    if (!activitiesData || !activitiesData.sessionMeetings) {
      return false
    }

    return activitiesData.sessionMeetings.length > 0
  } catch (error) {
    return false
  }
}

export async function getMeetingsCount(projectId: string): Promise<number> {
  try {
    const activitiesData = await getActivities(projectId, 1)

    if (!activitiesData || !activitiesData.sessionMeetings) {
      return 0
    }

    return activitiesData.sessionMeetings.length
  } catch (error) {
    return 0
  }
}
